import Navigation from '@/components/navigation/Navigation'
import MyIdicare from '@/components/page/MyIdicare'

export default [
	{
		path: '/:user_uid/my-idicare',
		name: 'MyIdicare',
		components: {
			default: MyIdicare,
			menu: Navigation
		},
		props: {
			default: true,
			menu: true
		}
	}
]



// WEBPACK FOOTER //
// ./src/router/modules/user/myidicare.js